/*
 * Room Spray 1+1 FREE
 *
 * Keeps auto-added free Room Spray lines in sync with the paid ones:
 * paid N -> free min(N, maxFree), added as separate lines flagged with
 * CONFIG.freeProperty. The price itself always comes from Shopify's
 * automatic Buy X Get Y discount; if Shopify does not discount the free
 * lines, they are removed again so nobody is charged for a "free" item.
 *
 * Settings live in snippets/roomspray-bogo.liquid.
 */
(function (root) {
  'use strict';

  if (root.leOliveRoomsprayBogo) return;

  var CONFIG = root.leOliveRoomsprayBogoConfig || {};
  var PAUSE_KEY = 'leOliveRoomsprayBogoPausedAt';
  var RELOAD_KEY = 'leOliveRoomsprayBogoReloadAt';
  var PAUSE_MS = 10 * 60 * 1000;
  var RELOAD_GUARD_MS = 3000;

  root.__leOliveCartGiftLock = root.__leOliveCartGiftLock || {
    chain: Promise.resolve(),
    run: function (fn) {
      var result = this.chain.then(fn, fn);
      this.chain = result.then(function () {}, function () {});
      return result;
    }
  };

  function num(value) {
    var n = Number(value);
    return isFinite(n) ? n : 0;
  }

  function t(key) {
    return (CONFIG.i18n && CONFIG.i18n[key]) || '';
  }

  function money(cents) {
    if (root.Shopify && typeof root.Shopify.formatMoney === 'function') {
      return root.Shopify.formatMoney(
        num(cents),
        (root.theme && root.theme.moneyFormat) || CONFIG.moneyFormat
      );
    }
    return '€' + (num(cents) / 100).toFixed(2).replace('.', ',');
  }

  function storageGet(key) {
    try {
      return root.sessionStorage ? root.sessionStorage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      if (root.sessionStorage) root.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function isPaused() {
    var pausedAt = num(storageGet(PAUSE_KEY));
    return pausedAt > 0 && Date.now() - pausedAt < PAUSE_MS;
  }

  function isEligible(item) {
    if (!item) return false;
    var id = num(item.product_id);
    return (CONFIG.productIds || []).some(function (productId) {
      return num(productId) === id;
    });
  }

  function isFree(item) {
    return (
      isEligible(item) &&
      !!item.properties &&
      item.properties[CONFIG.freeProperty] === 'true'
    );
  }

  function isBogoAllocation(allocation) {
    var app = (allocation && allocation.discount_application) || {};
    var title = String(app.title || '').trim().toLowerCase();
    var wanted = String(CONFIG.discountTitle || '').trim().toLowerCase();
    if (wanted && title === wanted) return true;
    return app.value_type === 'percentage' && num(app.value) >= 100;
  }

  function lineBogoAmount(item) {
    return ((item && item.line_level_discount_allocations) || []).reduce(
      function (sum, allocation) {
        return isBogoAllocation(allocation) ? sum + num(allocation.amount) : sum;
      },
      0
    );
  }

  function getState(cart) {
    var state = {
      enabled: CONFIG.enabled === true,
      maxFree: num(CONFIG.maxFree) || 2,
      paidQty: 0,
      freeQty: 0,
      paidLines: [],
      freeLines: [],
      bogoDiscount: 0,
      freeOriginal: 0,
      minUnitPrice: 0
    };
    var minUnitPrice = null;

    ((cart && cart.items) || []).forEach(function (item) {
      if (!isEligible(item)) return;
      var qty = num(item.quantity);
      if (isFree(item)) {
        state.freeQty += qty;
        state.freeLines.push(item);
        state.freeOriginal += num(item.original_line_price);
      } else {
        state.paidQty += qty;
        state.paidLines.push(item);
      }
      state.bogoDiscount += lineBogoAmount(item);
      var unit = num(item.original_price);
      if (minUnitPrice === null || unit < minUnitPrice) minUnitPrice = unit;
    });

    state.minUnitPrice = minUnitPrice || 0;
    state.desiredFree = state.enabled ? Math.min(state.paidQty, state.maxFree) : 0;
    state.discountApplied =
      state.freeQty > 0 &&
      state.bogoDiscount + 1 >= state.freeQty * state.minUnitPrice;
    // Shopify may put the discount on a paid line instead of the free one
    // (same price). When the totals match exactly, show it on the free line.
    state.exact =
      state.freeQty > 0 && Math.abs(state.bogoDiscount - state.freeOriginal) <= 1;
    return state;
  }

  function targetFreeQty(state) {
    return isPaused() ? 0 : state.desiredFree;
  }

  function isInSync(state) {
    return (
      state.freeQty === targetFreeQty(state) &&
      (state.freeQty === 0 || state.discountApplied)
    );
  }

  function hasEligible(cart) {
    return ((cart && cart.items) || []).some(isEligible);
  }

  /* ---------- cart requests ---------- */

  function cartFetch(url, options) {
    var fetchFn = root.fetch.bind(root);
    return fetchFn(url, options).then(function (response) {
      if (!response.ok) {
        var error = new Error('Roomspray 1+1 request failed: ' + url + ' (' + response.status + ')');
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }

  function getCart() {
    return cartFetch('/cart.js?ts=' + Date.now(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
  }

  function postJson(url, body) {
    return cartFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function changeLine(item, quantity) {
    return postJson('/cart/change.js', { id: item.key, quantity: quantity });
  }

  function addFreeUnit(variantId) {
    var properties = {};
    properties[CONFIG.freeProperty] = 'true';
    return postJson('/cart/add.js', {
      items: [{ id: num(variantId), quantity: 1, properties: properties }]
    });
  }

  /* ---------- sync ---------- */

  function paidVariantOrder(state) {
    var order = [];
    state.paidLines.forEach(function (line) {
      var id = String(line.variant_id);
      if (order.indexOf(id) === -1) order.push(id);
    });
    return order;
  }

  // Free units mirror the paid lines in cart order: paid A x1 + B x1 -> free A + B.
  function plannedFreeVariants(state, target) {
    var units = [];
    state.paidLines.forEach(function (line) {
      for (var i = 0; i < num(line.quantity) && units.length < target; i++) {
        units.push(String(line.variant_id));
      }
    });
    return units;
  }

  function reduceFreeLines(state, target) {
    var paidVariants = paidVariantOrder(state);
    var excess = state.freeQty - target;
    var lines = state.freeLines.slice().sort(function (a, b) {
      var aOrphan = paidVariants.indexOf(String(a.variant_id)) === -1 ? 0 : 1;
      var bOrphan = paidVariants.indexOf(String(b.variant_id)) === -1 ? 0 : 1;
      return aOrphan - bOrphan;
    });
    var chain = Promise.resolve();
    lines.forEach(function (line) {
      if (excess <= 0) return;
      var cut = Math.min(num(line.quantity), excess);
      excess -= cut;
      chain = chain.then(function () {
        return changeLine(line, num(line.quantity) - cut);
      });
    });
    return chain;
  }

  function addFreeLines(state, target) {
    var have = {};
    state.freeLines.forEach(function (line) {
      var id = String(line.variant_id);
      have[id] = (have[id] || 0) + num(line.quantity);
    });

    var missing = [];
    plannedFreeVariants(state, target).forEach(function (id) {
      if (have[id] > 0) have[id] -= 1;
      else missing.push(id);
    });
    missing = missing.slice(0, target - state.freeQty);

    var fallbacks = paidVariantOrder(state);
    var chain = Promise.resolve();
    missing.forEach(function (variantId) {
      var candidates = [variantId].concat(
        fallbacks.filter(function (id) { return id !== variantId; })
      );
      chain = chain.then(function () {
        return candidates.reduce(function (attempt, candidate) {
          return attempt.catch(function () {
            return addFreeUnit(candidate);
          });
        }, Promise.reject()).catch(function (error) {
          console.warn('[Roomspray 1+1] Could not add free Room Spray:', error);
        });
      });
    });
    return chain;
  }

  function removeAllFreeLines(state) {
    var chain = Promise.resolve();
    state.freeLines.forEach(function (line) {
      chain = chain.then(function () {
        return changeLine(line, 0);
      });
    });
    return chain;
  }

  function doSync() {
    return getCart().then(function (cart) {
      var state = getState(cart);
      var target = targetFreeQty(state);
      var attempted = state.freeQty !== target;
      var adjust = Promise.resolve();

      if (state.freeQty > target) {
        adjust = reduceFreeLines(state, target);
      } else if (state.freeQty < target) {
        adjust = addFreeLines(state, target);
      }

      return adjust
        .then(function () {
          return attempted ? getCart() : cart;
        })
        .then(function (fresh) {
          var freshState = getState(fresh);
          var changed = freshState.freeQty !== state.freeQty;
          if (freshState.freeQty === 0 || freshState.discountApplied) {
            return { changed: changed, cart: fresh };
          }
          // The automatic discount is not active (or another discount wins):
          // never leave "free" lines in the cart at full price.
          console.warn('[Roomspray 1+1] Shopify did not discount the free Room Spray; removing it.');
          storageSet(PAUSE_KEY, String(Date.now()));
          return removeAllFreeLines(freshState)
            .then(getCart)
            .then(function (finalCart) {
              return { changed: getState(finalCart).freeQty !== state.freeQty, cart: finalCart };
            });
        });
    });
  }

  var running = null;
  var rerun = false;

  function sync() {
    if (running) {
      rerun = true;
      return running;
    }

    running = root.__leOliveCartGiftLock
      .run(doSync)
      .catch(function (error) {
        console.error('[Roomspray 1+1] Sync failed:', error);
        return { changed: false, cart: null };
      })
      .then(function (result) {
        running = null;
        if (!rerun) return result;
        rerun = false;
        return sync().then(function (next) {
          return { changed: result.changed || next.changed, cart: next.cart };
        });
      });

    return running;
  }

  // Sync, then let the scent-card script recount (free sprays get a card too).
  function syncAll() {
    return sync().then(function (result) {
      if (!result.changed || typeof root.handleFreeScentCard !== 'function') {
        return result;
      }
      return Promise.resolve(
        root.handleFreeScentCard({ force: true, skipRefresh: true })
      ).then(
        function () { return result; },
        function () { return result; }
      );
    });
  }

  /* ---------- display ---------- */

  function lineDisplay(item, state) {
    if (!state || !state.enabled || !isEligible(item)) return null;

    var free = isFree(item);
    var original = num(item.original_line_price);
    var display = num(item.final_line_price);
    if (state.exact) {
      display = free ? 0 : display + lineBogoAmount(item);
    }

    var unitHtml = free && state.exact
      ? '<span class="cart-price-old">' + money(item.original_price) + '</span> ' +
        '<span class="cart-price-free">' + t('freeWord') + '</span>'
      : money(item.original_price);

    var lineHtml = display < original
      ? '<span class="cart-price-old">' + money(original) + '</span> ' + money(display)
      : money(display);

    var labelHtml = free
      ? '<div class="rs-bogo-label rs-bogo-label--free">' + t('freeLineLabel') + '</div>'
      : '';

    return { free: free, unitHtml: unitHtml, lineHtml: lineHtml, labelHtml: labelHtml };
  }

  function messageKey(state) {
    if (!state || !state.enabled || !state.paidQty || !state.freeQty || !state.discountApplied) {
      return '';
    }
    if (state.freeQty >= state.maxFree) return 'messageMax';
    return state.paidQty < state.maxFree ? 'messageOne' : 'messageAdded';
  }

  function messageHtml(state, modifier) {
    var key = messageKey(state);
    if (!key) return '';
    return (
      '<div class="rs-bogo-message' + (modifier ? ' rs-bogo-message--' + modifier : '') + '">' +
        '<span class="rs-bogo-message__badge">' + t('badge') + '</span>' +
        '<span class="rs-bogo-message__text">' + t(key) + '</span>' +
        (state.bogoDiscount > 0
          ? '<span class="rs-bogo-message__saving">' + t('savingLabel') + ' ' + money(state.bogoDiscount) + '</span>'
          : '') +
      '</div>'
    );
  }

  /* ---------- cart page ---------- */

  function reloadOnce() {
    var last = num(storageGet(RELOAD_KEY));
    if (Date.now() - last < RELOAD_GUARD_MS) return;
    storageSet(RELOAD_KEY, String(Date.now()));
    root.location.replace(root.location.pathname + root.location.search + root.location.hash);
  }

  function bootCartPage() {
    var el = root.document.querySelector('.js-cart-json');
    if (!el) return;
    var cart;
    try {
      cart = JSON.parse(el.textContent);
    } catch (error) {
      return;
    }
    if (!hasEligible(cart) || isInSync(getState(cart))) return;
    syncAll().then(function (result) {
      if (result.changed) reloadOnce();
    });
  }

  root.leOliveRoomsprayBogo = {
    config: CONFIG,
    t: t,
    money: money,
    isEligible: isEligible,
    isFree: isFree,
    hasEligible: hasEligible,
    getState: getState,
    isInSync: isInSync,
    lineDisplay: lineDisplay,
    messageKey: messageKey,
    messageHtml: messageHtml,
    sync: sync,
    syncAll: syncAll
  };

  if (root.document) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', bootCartPage);
    } else {
      bootCartPage();
    }
  }
})(window);
